module.exports = __webpack_public_path__ + "static/img/user_avatar.54aa99ea.jpg";